import { createTRPCReact } from "@trpc/react-query";
import type { AppRouter } from "@steperp/api/src/routers/index.js";

export const trpc = createTRPCReact<AppRouter>();
